import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import _fetchFlag from "./services/fetchFlag";
import fetchArrayFlags from "./utils/fetchArrayFlags";
import setFlagInObject from "./utils/setFlagInObject";
import setFlagsAsLoading from "./utils/setFlagsAsLoading";
export function createFeatureFlagStore(args) {
  return create()(devtools(function (set, get) {
    return {
      flags: {},
      metadata: {
        organizationId: args.organizationId,
        isOrganizationIdResolved: args.organizationId > 0
      },
      setMetadata: function setMetadata(metadata) {
        set({
          metadata: metadata
        });
      },
      getFlag: function getFlag(flagKey) {
        return get().flags[flagKey];
      },
      getFlagAndRegister: function getFlagAndRegister(flagKey, source) {
        var registeredFlag = get().getFlag(flagKey);
        if (!registeredFlag) {
          // Add flag to store and fetch its value
          get().fetchFlag(flagKey, source);

          // Retrieve flag from store (it should be there now after fetching)
          registeredFlag = get().getFlag(flagKey);
        }
        return registeredFlag;
      },
      setFlag: function setFlag(flagKey, flagValue, source) {
        var loading = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        var error = arguments.length > 4 ? arguments[4] : undefined;
        set({
          flags: setFlagInObject(get().flags, {
            flagName: flagKey,
            flagValue: flagValue,
            loading: loading,
            apiVersion: source,
            error: error
          })
        });
      },
      setBatchFlags: function setBatchFlags(flags) {
        var newFlags = {};
        flags.forEach(function (flag) {
          newFlags = setFlagInObject(newFlags, {
            flagName: flag.flagName,
            flagValue: flag.flagValue,
            loading: flag.loading,
            apiVersion: flag.apiVersion,
            error: flag.error
          });
        });
        set({
          flags: _objectSpread(_objectSpread({}, get().flags), newFlags)
        });
      },
      fetchFlag: function () {
        var _fetchFlag2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(flagKey, source) {
          var response, activatedFlag;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (get().metadata.isOrganizationIdResolved) {
                  _context.n = 1;
                  break;
                }
                get().setFlag(flagKey, false, source, true);
                return _context.a(2);
              case 1:
                // Set flag 'loading' to true while fetching
                get().setFlag(flagKey, false, source, true);

                // Fetch flag value
                _context.n = 2;
                return _fetchFlag(flagKey, source, {
                  organizationId: get().metadata.organizationId
                });
              case 2:
                response = _context.v;
                activatedFlag = response.flagValue; // Set flag value and 'loading' to false
                get().setFlag(flagKey, activatedFlag, source, false);
              case 3:
                return _context.a(2);
            }
          }, _callee);
        }));
        function fetchFlag(_x, _x2) {
          return _fetchFlag2.apply(this, arguments);
        }
        return fetchFlag;
      }(),
      fetchAllFlags: function () {
        var _fetchAllFlags = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(flags) {
          var newFlags, responses;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                // Set all flags 'loading' to true while fetching
                newFlags = setFlagsAsLoading(flags);
                get().setBatchFlags(newFlags);

                // Skip network requests until organizationId is resolved
                if (get().metadata.isOrganizationIdResolved) {
                  _context2.n = 1;
                  break;
                }
                return _context2.a(2);
              case 1:
                _context2.n = 2;
                return fetchArrayFlags(flags, get().metadata.organizationId);
              case 2:
                responses = _context2.v;
                newFlags = responses.map(function (response) {
                  return {
                    flagName: response.flagKey,
                    flagValue: response.flagValue,
                    apiVersion: response.apiVersion,
                    error: response.error,
                    loading: false
                  };
                });
                get().setBatchFlags(newFlags);
              case 3:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        function fetchAllFlags(_x3) {
          return _fetchAllFlags.apply(this, arguments);
        }
        return fetchAllFlags;
      }()
    };
  }));
}